export default "__VITE_ASSET__BDiuozqI__"